import React from 'react'
import { Divider, Grid, ListItem, ListItemText } from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import '../ReceiptForm/Receipt.scss'

export const ReceiptDetailItemContent = (props: any) => {
  const { listItem } = props
  return (
    <>
      <div className="rm-padding table-wrap ">
        {listItem?.map((el, index) => {
          return (
            <>
              <ListItem className="table-listItem" key={index} divider>
                <Grid container>
                  <ListItemText
                    primary={
                      <>
                        <Grid container>
                          <Grid item xs={1} component="span">
                            <span className="desc text-noflow">
                              {index + 1}.
                            </span>
                          </Grid>
                          <Grid item xs={8} component="span">
                            <span className="desc text-noflow">Amount:</span>
                            <span className="p-l-3 desc text-noflow">
                              {amtStr(el?.Amount)}
                            </span>
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            component="span"
                            className="right-text"
                          >
                            <span className="p-l-3 desc text-noflow">
                              {amtStr(el?.DocAmt)}
                            </span>
                          </Grid>
                        </Grid>
                      </>
                    }
                    secondary={
                      <>
                        <Grid container>
                          <Grid item xs={1} component="span"></Grid>
                          <Grid item xs={11} component="div">
                            <span className="desc text-noflow">
                              Tax Amount:
                            </span>
                            <span className="p-l-3 desc text-noflow">
                              {amtStr(el?.TaxAmt) + ` | ` + el?.TaxScheme?.Name}
                            </span>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs={1} component="span"></Grid>
                          <Grid item xs={11} component="div">
                            <span className="desc text-noflow">
                              {el?.MasterCOA?.Code} | {el?.MasterCOA?.Name}
                            </span>
                          </Grid>
                        </Grid>

                        <Grid container>
                          <Grid item xs={1} component="span"></Grid>
                          <Grid item xs={11} component="div">
                            <div className="desc text-noflow">
                              {el?.CostCentre?.MasterCode}
                            </div>
                          </Grid>
                        </Grid>

                        <Grid container>
                          <Grid item xs={1} component="span"></Grid>
                          <Grid item xs={11} component="div">
                            <div className="desc text-noflow">
                              {el?.Remark ?? ''}
                            </div>
                          </Grid>
                        </Grid>
                      </>
                    }
                  />
                </Grid>
              </ListItem>

              {index !== listItem?.length - 1 && (
                <Divider
                  variant="fullWidth"
                  style={{ background: '#E4E4E4' }}
                />
              )}
            </>
          )
        })}
      </div>
      <div className="footer-label" style={{ background: '#bfd3ff' }} />
    </>
  )
}
